import Permissions from '@/permissions'

const getMeta = (permissions, link) => {
  return {
    permissions,
    groups: 'position',
    breadcrumb: [
      {
        name_en: 'Settings',
        name_km: 'ការកំណត់'
      },
      {
        name_en: 'Position',
        name_km: 'តួនាទី'
      },
      link
    ]
  }
}

const position = Permissions.backend.setting.position

export const positionRouters = {
  path: 'position',
  component: () => import('@/views/settings/position/Index'),
  redirect: 'position',
  meta: {
    permissions: [position.manage],
    groups: 'position'
  },
  children: [
    {
      path: '',
      name: 'list-position',
      component: () => import('@/views/settings/position/List'),
      meta: getMeta([position.list], {
        name_en: 'List',
        name_km: 'List'
      })
    },
    {
      path: 'create',
      name: 'create-position',
      component: () => import('@/views/settings/position/Create'),
      meta: getMeta([position.store], {
        name_en: 'Create',
        name_km: 'បង្កើត'
      })
    },
    {
      path: 'edit/:uuid',
      name: 'edit-position',
      component: () => import('@/views/settings/position/Edit'),
      meta: getMeta([position.edit], {
        name_en: 'Edit',
        name_km: 'កែសំរួល'
      })
    }
  ]
}
